module.exports = "/_next/static/resources/life2-864997aae33f926e78df31593e6b848d.jpg";